import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d8822c40&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8822c40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8822c40')) {
      api.createRecord('d8822c40', component.options)
    } else {
      api.reload('d8822c40', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=d8822c40&scoped=true", function () {
      api.rerender('d8822c40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/withdraw/config/list.vue"
export default component.exports